module.exports = "/assets/data/c1d5a6b0dfd1ac527ea8d7645663f915-NE1.data.json";